import { render, staticRenderFns } from "./FeaturedCheck.vue?vue&type=template&id=1729fa87&scoped=true&"
import script from "./FeaturedCheck.vue?vue&type=script&lang=js&"
export * from "./FeaturedCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729fa87",
  null
  
)

export default component.exports